import { Icon, IconProps } from '@chakra-ui/react';

export const NextIcon = (props: IconProps) => (
  <Icon width='5px' height='9px' viewBox='0 0 5 9' fill='black' {...props}>
    <path
      d='M-1.12229e-07 7.71429L3.125 4.5L-6.73372e-07 1.28571L0.624999 5.0227e-07L5 4.5L0.625 9L-1.12229e-07 7.71429Z'
      fill='inherit'
    />
  </Icon>
);
